<template>
  <img
    src="/crtify.svg"
    style="height: 40px; width: auto;"
    alt="Crtify"
  >
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>
